import { CaseUserRef } from "../shared/CaseModel.ts";

// The claimed-amount calculations now live in shared so the server can use
// them too (e.g. to enrich the case list). Re-exported here to keep existing
// client import sites working.
export {
  getAmountClaimedByParties,
  getAmountClaimedAgainstParties,
} from "../shared/CaseModelUtility.ts";

/**
 * The name to attribute a case timestamp to, or undefined when there is none to
 * show. Attribution is missing on every case saved before it was recorded, and
 * stays missing where the backfill could not identify a creator, so callers must
 * fall back to an unattributed label rather than interpolating this.
 *
 * Defensive about the shape as well as the presence: this comes straight off a
 * Parse column, so a hand-edited or half-written value must degrade to
 * "unknown" rather than throw.
 */
export function attributionName(by?: CaseUserRef): string | undefined {
  const name = by?.name;
  if (typeof name !== "string") return undefined;
  return name.trim() || undefined;
}
